import "core-js/modules/es6.array.find";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
import { LOCALES, DEFAULT_LOCALE } from '~/const/i18n';
export default {
  nuxtServerInit: function () {
    var _nuxtServerInit = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref, _ref2) {
      var commit, params, req, locale, protocol, baseURL;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              params = _ref2.params, req = _ref2.req;
              locale = LOCALES.filter(function (obj) {
                return obj.market === params.market;
              }).find(function (obj) {
                return obj.language === params.language;
              }) || DEFAULT_LOCALE;
              commit('i18n/SET_LOCALE', locale);
              this.app.i18n.locale = locale.language;
              protocol = req.headers['x-forwarded-proto'] || 'http';
              baseURL = req ? "".concat(protocol, "://").concat(req.headers.host) : '';
              commit('request/SET_BASE_URL', baseURL);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function nuxtServerInit(_x, _x2) {
      return _nuxtServerInit.apply(this, arguments);
    }

    return nuxtServerInit;
  }()
};